module.exports = __webpack_public_path__ + "static/img/bg2.5ba9986.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/double11/3/bg2.jpg
// module id = HFE/
// module chunks = 0